import Vue from "vue";
import StickyHeader from "@/features/header/components/sticky-header";
import VueI18n from "vue-i18n";
import getLocale from "@/utils/locale";
import getWindowTop from "@/utils/get-window-top";
import store from "@/store/";

const initStickyHeader = (active) => {
  const container = document.getElementById("sticky-header");

  if (!container) {
    return;
  }

  const hasSignupLink = container.dataset.stickyHeaderSignupLink === "true";
  const cta = container.dataset.cta && JSON.parse(container.dataset.cta);

  Vue.use(VueI18n);

  const vm = new Vue({
    name: "StickyHeaderInit",
    el: container,
    components: { StickyHeader },
    store,
    i18n: new VueI18n({ locale: getLocale() }),
    data() {
      return {
        hasSignupLink: hasSignupLink,
        active
      };
    },
    render (createElement) {
      return createElement(StickyHeader, {
        props: {
          hasSignupLink: this.hasSignupLink,
          active: this.active,
          cta
        }
      });
    }
  });

  const onScroll = () => {
    const ref = document.querySelector(".js-sticky-header-ref");
    const isSticky = ref
      ? ref.getBoundingClientRect().top < 0
      : getWindowTop() > window.innerHeight;
    vm.active = isSticky;
  };

  window.addEventListener("scroll", onScroll);
  onScroll();
};

export default initStickyHeader;
